<template>
  <div>
    <DataScDashboard />
    <!-- <div v-if="user.role.toLowerCase() == 'data scientist'">
      <AdminDashboard />
    </div>
    <div v-else-if="user.role.toLowerCase() == 'admin'">
      <DataScDashboard />
    </div> -->
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin"; 
import DataScDashboard from "./DashboardForDataSc.vue";
import ProfileService from "../../_services/ProfileService";

export default {
  async mounted() {
    document.title = "Dashboard";
    this.startLoading();
    setTimeout(() => {
      this.stopLoading();
    }, 1000);
  },
  components: {  DataScDashboard },
  created() {
    this.getProfileData();
  },
  data() {
    return {
      loading: true,
      user: {
        name: "",
        role: "",
        userName: "",
      },
    };
  },
  methods: {
    getProfileData() {
      ProfileService.getProfileData()
        .then((res) => {
          if (res.success) {
            this.user.role = res.data.role;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
.border {
  border: 2px solid;
  border-color: #dae1ec;
}
</style>
